export default "__VITE_ASSET__TRB9DqoM__"